/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import { LoggerModule } from "@vlinder-web/logger-module-react";

import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { VApplication } from "../../../application";
import { UPDATE_VALID_EMAIL_ID } from "../graphql/updateValidEmailID.mutation";

const log: any = LoggerModule?.getInstance();

const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export interface IUpdateValidEmailIDMethods extends IPluginMethodMap {
  updateValidEmailID(args: any): Promise<any>;
}

export class UpdateValidEmailIDService implements IAgentPlugin {
  readonly methods: IUpdateValidEmailIDMethods;

  constructor() {
    this.methods = {
      updateValidEmailID: this.updateValidEmailID.bind(this),
    };
  }

  async updateValidEmailID(args: any) {
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");

    try {
      if (client) {
        const res = await client.mutate({
          mutation: UPDATE_VALID_EMAIL_ID,
          variables: {
            data: {
              costumeId: args?.costumeId,
              dummyEmail: args?.dummyEmail,
              validEmail: args?.validEmail,
            },
          },
          fetchPolicy: "no-cache",
        });
        if (res?.data?.UpdateValidEmailD) {
          return {
            ...res?.data?.UpdateValidEmailD,
          };
        }
      }
    } catch (err: any) {
      let _display_message =
        err?.graphQLErrors &&
        Array.isArray(err?.graphQLErrors) &&
        err?.graphQLErrors.find((item: any) => item.extensions);
      if (_display_message?.extensions?.display_message) {
        throw Error(_display_message?.extensions?.display_message);
      }

      throw err;
    }
  }
}
